// "Criar modelo" a partir de um orcamento.
//
// Diferente da conversao, que TRANSFORMA o registro: aqui nasce um documento NOVO, copia do
// original, com tipo Modelo. O orcamento de origem nao e tocado.
//
// Como em mover-venda-etapa.request, a lista de vendedores permitidos NAO vem daqui: quem
// resolve o escopo do usuario logado e o OrquestradorVendas.
export class CriarModeloVendaRequest {
    public idVenda: number;
}
